@use "../../styles/breakpoint.module.scss" as *;

// When the bar is on the page, raise the footer's bottom padding so the
// fixed bar doesn't occlude content. Consumed by Footer.module.scss.
:global(html):has(.bar) {
    --footer-padding-bottom: var(--spacer-104);
}

.sentinel {
    grid-column: 1 / -1;
    height: 0;
    overflow: hidden;
    pointer-events: none;
}

.bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background-color: var(--white);
    box-shadow: var(--box-shadow-4);
    z-index: 50;
    transform: translateY(100%);
    visibility: hidden;
    transition:
        transform 0.3s ease,
        visibility 0.3s;

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }

    @media ($below-mobile) {
        height: 64px;
    }

    &[data-visible="true"] {
        transform: translateY(0);
        visibility: visible;
    }
}

.inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-32);
    height: 100%;
    padding-inline: var(--spacer-margin);
}

.text {
    composes: fontB20 from "../../styles/typography.module.scss";
    color: var(--black);
    margin: 0;
}
